<template>
  <form
    class="flex flex-col overflow-hidden rounded sm:flex-row sm:rounded-full"
    name="mail"
    @submit.prevent="sendEmailToDb"
  >
    <input
      class="w-full px-6 py-3 text-black placeholder-gray-500 rounded-full focus:outline-0 sm:rounded-none"
      type="email"
      name="email"
      placeholder="felix@herdingcats.fr"
      v-model="emailAddress"
    />
    <button
      class="px-6 py-3 mt-2 font-bold tracking-wider text-white uppercase bg-green-500 rounded-full sm:mt-0 sm:rounded-none"
    >Envoyer</button>
  </form>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBkp9x0TNV0PFc1TCXuFfZNXvXED5Co68c",
  authDomain: "herdingcats-65299.firebaseapp.com",
  databaseURL: "https://herdingcats-65299.firebaseio.com",
  projectId: "herdingcats-65299",
  storageBucket: "herdingcats-65299.appspot.com",
  messagingSenderId: "208935927776",
  appId: "1:208935927776:web:39b5badb5b290bee"
};

function getURLParameter(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.search
      ) || [null, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default {
  data: function() {
    return {
      emailAddress: ""
    };
  },
  props: {
    forceAngle: {
      default: null,
      type: String
    },
    // isGpsEnabled: {
    //   default: true,
    //   type: Boolean
    // }
  },
  methods: {
    sendEmailToDb: function() {
      const { emailAddress } = this;
      if (emailAddress.length < 5) {
        console.error("Name too short");
        return;
      }
      let angle = this.forceAngle || getURLParameter("ref");
      if (
        !(
          angle === "1" ||
          angle === "2" ||
          angle === "3" ||
          angle === "4" ||
          angle === "5" ||
          angle === "6"
        )
      ) {
        angle = "0";
      }
      // if (this.isGpsEnabled == false) {
      //   angle = "7"
      // }
      firebase
        .firestore()
        .collection(`subscribers_angle${angle}`)
        .add({
          emailAddress
        })
        .then(docRef => {
          // Success handler here
          // this.$refs.notif.displayToast()
          // if (this.isGpsEnabled == true) {
          //   window.location = "/thanks";
          // } else if (this.isGpsEnabled == false) {
          //   window.location = "/thanks?activity=1";
          // }
          window.location = "/thanks";
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>